export default "__VITE_ASSET__67565cbd__"